//
// Copyright (c) 2011-2023 by Curalate, Inc.
//

import {
  OAUTH_ERROR_PARAM,
  OAUTH_NETWORK_PARAM,
} from '@account-settings/accountSettingsConstants';

export interface ITikTokSettingsState {
  errors: {
    fetchOauthUrlError: string | undefined;
    fetchSettingsError: string | undefined;
    connectError: string | undefined;
    disconnectError: string | undefined;
    reconnectError: string | undefined;
  };
  flags: {
    isFetchingOAuthUrl: boolean;
    isFetchingSettings: boolean;
    isConnecting: boolean;
    isDisconnecting: boolean;
    isReconnecting: boolean;
  };
  isConnected: boolean;
  connectedAccount: ITikTokAccount | undefined;
  hasStaleCredentials: boolean;
  oauthEndpoint: string | undefined;
}

export interface ITikTokAccount {
  displayName: string | undefined;
  scope: string[] | undefined;
}

export const requiredTikTokScopeNames = {
  'user.account.type': 'View Account Type',
  'user.info.basic': 'Basic User Info',
  'user.info.stats': 'View User Stats',
  'user.info.username': 'View Username',
  'user.insights': 'User Insights',
  'video.list': 'View Videos',
  'video.insights': 'Video Insights',
  'video.publish': 'Upload Videos',
  'comment.list': 'View Comments',
  'comment.list.manage': 'Manage Comments',
};

// TODO: PD-285704: Remove this once tiktok mentions ingestion feature flag is released
export const getRequiredTikTokScopeNames = (
  getIsTikTokMentionsFeatureEnabled: boolean,
 ) => {
   return getIsTikTokMentionsFeatureEnabled
     ? { ...requiredTikTokScopeNames, 'biz.brand.insights': 'Brand Insights' }
     : requiredTikTokScopeNames;
};

export const TIKTOK_OAUTH_NETWORK_PARAM = OAUTH_NETWORK_PARAM;
export const TIKTOK_OAUTH_ERROR_PARAM = OAUTH_ERROR_PARAM;
export const TIKTOK_OAUTH_NETWORK = 'TikTok';
export const TIKTOK_OAUTH_ERRORS = {
  '0': 'TikTok failed to connect',
};

type ErrorParam =
  `&${typeof TIKTOK_OAUTH_ERROR_PARAM}=${keyof typeof TIKTOK_OAUTH_ERRORS}`;

type SettingsUrl =
  `/account-settings/social-media?${typeof TIKTOK_OAUTH_NETWORK_PARAM}=${typeof TIKTOK_OAUTH_NETWORK}`;

type SettingsUrlWithError =
  `/account-settings/social-media?${typeof TIKTOK_OAUTH_NETWORK_PARAM}=${typeof TIKTOK_OAUTH_NETWORK}${ErrorParam}`;

export const TIKTOK_SETTINGS_URL: SettingsUrl = `/account-settings/social-media?${TIKTOK_OAUTH_NETWORK_PARAM}=${TIKTOK_OAUTH_NETWORK}`;

export const getTikTokSettingsUrlWithError = (
  errorCode: keyof typeof TIKTOK_OAUTH_ERRORS,
): SettingsUrlWithError =>
  `${TIKTOK_SETTINGS_URL}&${TIKTOK_OAUTH_ERROR_PARAM}=${errorCode}`;
